import type { ReactNode } from 'react'
import { cx } from '../cx'
import styles from './SectionLabel.module.css'

export type LabelTone = 'ember' | 'blood' | 'muted' | 'arcane'

export interface SectionLabelProps {
  children: ReactNode
  tone?: LabelTone
  /** Renders at micro size (spec §3.2: 10–11px, +1.5 tracking) — used above form fields. */
  micro?: boolean
  className?: string | undefined
  id?: string | undefined
}

/** All-caps section label. Spec §3.2 "Section label" and §4 "Card". */
export function SectionLabel({
  children,
  tone = 'ember',
  micro = false,
  className,
  id,
}: SectionLabelProps) {
  return (
    <span id={id} className={cx(styles.label, styles[tone], micro && styles.micro, className)}>
      {children}
    </span>
  )
}
